import { today, tomorrow } from '@/utils/date'
import moment from 'moment'

export default defineNuxtRouteMiddleware(to => {
  if (to.path.includes('/dates/today')) {
    const todayDate = today().split('/')
    to.params.year = todayDate[0]
    to.params.month = todayDate[1]
    to.params.day = todayDate[2]
  } else if (to.path.includes('/dates/tomorrow')) {
    const tomorrowDate = tomorrow().split('/')
    to.params.year = tomorrowDate[0]
    to.params.month = tomorrowDate[1]
    to.params.day = tomorrowDate[2]
  } else if (to.path.includes('/dates/weekend')) {
    const saturday = moment().endOf('week')
    const sunday = moment(saturday).add(1, 'days')
    to.query['from-year'] = saturday.year()
    to.query['from-month'] = saturday.month() + 1
    to.query['from-day'] = saturday.date()
    to.query['to-year'] = sunday.year()
    to.query['to-month'] = sunday.month() + 1
    to.query['to-day'] = sunday.date()
  }
})
